var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22517 4.81108C5.83465 4.42056 5.20148 4.42056 4.81096 4.81108C4.42044 5.20161 4.42044 5.83477 4.81096 6.2253L10.5857 12L4.81102 17.7747C4.4205 18.1652 4.42049 18.7984 4.81102 19.1889C5.20154 19.5794 5.83471 19.5794 6.22523 19.1889L11.9999 13.4142L17.7746 19.1889C18.1651 19.5794 18.7983 19.5794 19.1888 19.1889C19.5793 18.7984 19.5793 18.1652 19.1888 17.7747L13.4141 12L19.1889 6.2253C19.5794 5.83477 19.5794 5.20161 19.1889 4.81108C18.7983 4.42056 18.1652 4.42056 17.7746 4.81108L11.9999 10.5858L6.22517 4.81108Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.a0aa8d5e64224995ebf60a5750d96432.svg";
export { ForwardRef as ReactComponent };